<template>
    <div class="acordeon-container">
        <button
            type="button"
            class="acordeon-header"
            :aria-expanded="isOpen"
            :aria-controls="contentId"
            :id="buttonId"
            @click="toggle"
        >
            <span class="title">{{ title }}</span>
            <div class="arrow-down" :class="{ open: isOpen }" />
        </button>
        <div
            :id="contentId"
            class="acordeon-content"
            role="region"
            :aria-labelledby="buttonId"
            :style="{ display: isOpen ? 'block' : 'none' }"
        >
            <slot />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';

export default defineComponent({
    name: 'Acordeon',
    props: {
        title: {
            type: String,
            required: false,
            default: '',
        },
    },
    setup() {
        const isOpen = ref(false);
        const accordionId = Math.random().toString(36).slice(2, 10);
        const buttonId = `acordeon-button-${accordionId}`;
        const contentId = `acordeon-content-${accordionId}`;

        const toggle = () => {
            isOpen.value = !isOpen.value;
        };

        return {
            isOpen,
            buttonId,
            contentId,
            toggle,
        };
    },
});
</script>

<style lang="scss">
.acordeon-container {
    border: 1px solid #d2d2d2;
    padding: 20px;

    .acordeon-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 0;
        border: none;
        background: transparent;
        cursor: pointer;

        &:focus-visible {
            outline: 2px solid #192241;
            outline-offset: 2px;
            border-radius: 4px;
        }

        .title {
            font-size: 16px;
            font-weight: 600;
        }

        .arrow-down {
            width: 12px;
            height: 12px;
            border-right: 2px solid #af1919;
            border-bottom: 2px solid #af1919;
            div.body.oanda & {
                border-color: #00d37e;
            }
            transform: rotate(45deg);
            transition: transform 0.3s ease;

            &.open {
                transform: rotate(225deg);
            }
        }
    }

    .acordeon-content {
        overflow: hidden;
        margin-top: 10px;
        transition: all 0.3s ease;
        margin-top: 40px;

        .alternate-button:focus-visible,
        .navigation-link:focus-visible {
            outline: none;
            border: 2px solid #192241;
            border-radius: 4px;
        }

        .alternate-button:focus-visible {
            padding: 19px;
        }

        .navigation-link {
            border: 2px solid transparent;
            border-radius: 4px;
        }
    }
}

.accordion-enter-active,
.accordion-leave-active {
    transition:
        max-height 0.3s ease,
        opacity 0.3s ease;
}
.accordion-enter,
.accordion-leave-to {
    max-height: 0;
    opacity: 0;
}
.accordion-enter-to,
.accordion-leave {
    max-height: 500px;
    opacity: 1;
}
</style>
